import { render } from "./MagicKitchenPresskit.vue?vue&type=template&id=5c2c7c41&scoped=true"
import script from "./MagicKitchenPresskit.vue?vue&type=script&lang=js"
export * from "./MagicKitchenPresskit.vue?vue&type=script&lang=js"

import "./MagicKitchenPresskit.vue?vue&type=style&index=0&id=5c2c7c41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2c7c41"]])

export default __exports__